/* eslint-disable */
import { takeEvery, call, put } from 'redux-saga/effects';
import { GET_FORGETPASSWORD, SET_FORGETPASSWORD } from '../actions';
import {apiUrl } from "../components/Config/Config";
import Axios from 'axios';

export const watchGetForgetPassword = function* () {
  yield takeEvery(GET_FORGETPASSWORD, workerGetForgetPassword);
}
function* workerGetForgetPassword({ formPayload }) {
  try {
 const result = yield call(getForgetPassword, formPayload);
	var resultArr = [];
	resultArr.push(result.data);
    yield put({ type: SET_FORGETPASSWORD, value: resultArr });
  } 
  catch {
    console.log('get data failed');
  }
} 


function getForgetPassword(formPayload) {
       return Axios.post(apiUrl+'adminpanel/forgot_password', formPayload);
} 
